export default {
  common: {
    save: "সংরক্ষণ করুন",
    cancel: "বাতিল করুন",
    back: "ফিরে যান",
    submit: "জমা দিন",
    loading: "লোড হচ্ছে…",
    yes: "হ্যাঁ",
    no: "না",
    confirm: "নিশ্চিত করুন",
    close: "বন্ধ করুন",
    search: "খুঁজুন",
    all: "সব",
    done: "সম্পন্ন",
    logout: "লগ আউট",
    language: "ভাষা",
    selectLanguage: "আপনার ভাষা নির্বাচন করুন",
    saving: "সংরক্ষণ হচ্ছে…",
    saved: "সংরক্ষিত হয়েছে",
    viewAll: "সব দেখুন",
    filters: "ফিল্টার",
  },
  nav: {
    home: "হোম",
    installs: "ইনস্টলেশন",
    requests: "অনুরোধ",
    orders: "অর্ডার",
    profile: "প্রোফাইল",
    leads: "লিড",
    service: "সেবা",
    payouts: "পেআউট",
    toolkit: "টুলকিট",
  },
  profile: {
    yourAccount: "আপনার অ্যাকাউন্ট",
    title: "প্রোফাইল.",
    city: "শহর",
    state: "রাজ্য",
    pinCode: "পিন কোড",
    pinCodeHelp: "এই পিন কোড যে অনুমোদিত অঞ্চলের অন্তর্ভুক্ত, সেটিই আপনার অঞ্চল।",
    upiId: "UPI আইডি (পেআউটের জন্য)",
    saveProfile: "প্রোফাইল সংরক্ষণ করুন",
    preferredLanguage: "পছন্দের ভাষা",
    logoutConfirm: "আপনি কি সত্যিই লগ আউট করতে চান?",
    linkedAddresses: "যুক্ত ঠিকানা",
    noAddresses: "এখনও কোনো ঠিকানা সংরক্ষিত নেই।",
    referFriend: "বন্ধুকে রেফার করুন",
    referFriendSub: "আপনার কোড শেয়ার করুন — তারা সোলার লাগালে আপনি পুরস্কার পাবেন।",
    myReferrals: "আমার রেফারেল",
    shareFriend: "বন্ধুর সাথে শেয়ার করুন",
    secureNote: "আপনার তথ্য নিরাপদ ফোন OTP দ্বারা যাচাই করা হয়েছে — পাসওয়ার্ড মনে রাখার বা হারানোর দরকার নেই।",
    toolkit: "টুলকিট",
    incentiveSchemes: "ইনসেনটিভ স্কিম",
  },
  tickets: {
    myRequests: "আমার অনুরোধ",
    raiseComplaint: "অভিযোগ দায়ের করুন",
    cancelRequest: "অনুরোধ বাতিল করুন",
    cancelConfirmTitle: "এই অনুরোধটি বাতিল করবেন?",
    cancelConfirmBody: "আমরা এই পরিষেবা অনুরোধে কাজ বন্ধ করে দেব। আপনি পরে আবার নতুন অনুরোধ করতে পারেন।",
    cancelledToast: "অনুরোধ বাতিল করা হয়েছে",
    keepRequest: "না, রাখুন",
    noRequests: "এখনও কোনো পরিষেবা অনুরোধ নেই।",
    statusOpen: "খোলা",
    statusInProgress: "চলমান",
    statusOnHold: "স্থগিত",
    statusActionNeeded: "পদক্ষেপ প্রয়োজন",
    statusCompleted: "সম্পন্ন",
    statusClosed: "বন্ধ",
    statusCancelled: "বাতিল",
    statusDropped: "বাদ দেওয়া হয়েছে",
    filterAll: "সব",
    filterActive: "সক্রিয়",
    filterResolved: "সমাধান হয়েছে",
    nonServiceable: "অ-পরিষেবাযোগ্য এলাকা",
    raisedOn: "দায়ের করা হয়েছে",
    ticketNumber: "টিকিট",
    wipInstall: "ইনস্টলেশন চলছে",
    raisedByYou: "আপনি দায়ের করেছেন",
    raisedByTeam: "আমাদের টিম দায়ের করেছে",
    timeline: "টাইমলাইন",
    pending: "অপেক্ষমাণ",
    resolutionSummary: "সমাধান সারাংশ",
    youRatedPrefix: "আপনি এটি রেট করেছেন",
    howWasResolution: "সমাধান কেমন ছিল?",
    submitFeedback: "ফিডব্যাক জমা দিন",
  },
  home: {
    greeting: "নমস্কার",
    newInstallation: "নতুন ইনস্টলেশন",
    raiseComplaint: "অভিযোগ দায়ের করুন",
    welcomeBack: "পুনরায় স্বাগতম",
    customerSubtitle: "পূর্বোদয়ের সাথে আপনার সোলার যাত্রা, সব একসাথে।",
  },
  sc: {
    requestsTitle: "সেবা অনুরোধ",
    requestsForCustomers: "আপনার গ্রাহকদের জন্য",
    kpiOpen: "খোলা",
    kpiResolved: "সমাধান হয়েছে",
    kpiInProblem: "সমস্যায়",
    raiseRequest: "সেবা অনুরোধ দায়ের করুন",
    slaBreached: "SLA লঙ্ঘন",
    viewPhotos: "ছবি দেখুন",
    hidePhotos: "ছবি লুকান",
    noRequestsWindow: "এই সময়কালে কোনো সেবা অনুরোধ নেই।",
  },
};
